import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import ReportsGrid from "./ReportsGrid";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function ReportsPage() {
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  document.title = "Base - Reports";

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Reports" }]} />

        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-sm-12 col-md-12">
            <ReportsGrid />
          </div>
          <div className="hidden-sm col-md-2"></div>
        </div>
      </div>
    </>
  );
});
